module.exports = __webpack_public_path__ + "img/tokyo.d569c0c2.png";